<template>
    <div id="page" class="page">

        <interne_menu></interne_menu>
               
        <section id="download-4" class="bg-fixed p-top-160 download-section division bck-cartes ">
            <div class="container">
                <div class="row">

                                
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Nos cartes <br>VISA Prépayée</h2>

                            <!-- Text -->
                            <p class="p-lg">La carte Visa Prépayée, la solution pour un achat en toute sécurité, sans compte bancaire.<br> Chargez seulement la somme souhaitée et utilisez-la où et quand vous voulez !<br> Commandez la vôtre dès maintenant</p>
                            

                            <!-- HERO STORE BADGES -->													
                            <div class="stores-badge">

                                <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-left txt_disp">Commander une carte</a>

                            </div>


                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->


                    <!-- DOWNLOAD IMAGE -->
<!--                    <div class="col-md-12 box-card">	-->
<!--                        -->
<!--                            <div class="row">-->

<!--                                <div class="col-md-4 div_car">-->
<!--                                    <img src="@/assets/images/carte-classique.png" class="img_card">-->
<!--                                    &lt;!&ndash; Button &ndash;&gt;						-->

<!--                                    &lt;!&ndash; Title &ndash;&gt;	-->
<!--                                    <h2 class=" title_card title_mob" >Carte Visa Classic</h2>-->
<!--                                    <p class="title_mob">En partenariat avec NSIA, la carte Abidjan.net est une carte Visa prépayée internationale hautement sécurisée.</p>                                -->

<!--                                    <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-left">Commander une carte</a>-->

<!--                                    &lt;!&ndash;btn reponsive&ndash;&gt;-->
<!--                                    <RouterLink to="carte-classic" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>-->
<!--                                    -->
<!--                                </div>-->
<!--                                &lt;!&ndash; CONTENT TEXT &ndash;&gt;-->
<!--                                <div class="col-md-8 txt_disp" >-->
<!--                                    <div class="content-txt ind-45">-->

<!--                                        &lt;!&ndash; Title &ndash;&gt;	-->
<!--                                        <h2 class=" title_card title1" >Carte Visa Classic</h2>-->
<!--                                        &lt;!&ndash; Text &ndash;&gt;-->
<!--                                        <p>En partenariat avec NSIA, la carte Abidjan.net est une carte Visa prépayée internationale hautement sécurisée,</p>-->
<!--                                        <p><span class="msform">Sécurisée :</span> Paiements en ligne par 3D Secure, bande magnétique, puce électronique et code secret</p>-->
<!--                                        <p><span class="msform">Achat dans le monde entier :</span> Sur internet (Alibaba/ Netflix/ Booster vos pages Facebook, Compte ITunes…) et dans les commerces physiques</p>-->
<!--                                        <p><span class="msform">Remise et privilèges :</span> Jusqu’à 25% chez les marchands partenaires</p>-->



<!--                                        <p><span class="msform">Rechargements :</span> Recharger jusqu’à 2 000 000 de FCFA/jour en espèce </p>-->
<!--                                        -->
<!--                                        -->

<!--                                        <p>                                           -->
<!--                                        &lt;!&ndash; Button &ndash;&gt;						-->
<!--                                        <RouterLink to="carte-classic" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>-->
<!--                                        -->
<!--                                        </p>-->

<!--                                        -->
<!--                                    </div>-->
<!--                                </div>	&lt;!&ndash; END CONTENT TEXT &ndash;&gt;                             -->
<!--                        </div>-->
<!--                    </div>-->


                    

                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

        <section id="download-4" class="bg-fixed download-section grey_bck_section division">
            <div class="container">
                <div class="row">
                    <!-- CARTE PLATINUM -->
                    <div class="col-md-12 box-card_right">	
                        
                            <div class="row">
                            <!-- CONTENT TEXT -->
                            <div class="col-md-8 txt_disp">
                            <div class="content-txt ind-45">
                                

                                <!-- Title -->	
                                <h2 class=" title_card title1" >Carte Visa Platinum Noir</h2>
                                <!-- Text -->
                                <p>En partenariat avec UBA, la carte Platinum Abidjan.net est une carte visa prépayée internationale hautement sécurisée qui est au prix de 50.000 FCFA avec un minimum de rechargement de 100 000 FCFA pour l’activation de la carte.</p>
                                <p><span class="msform">Sécurisée :</span> Paiements en ligne par 3D Secure, bande magnétique, puce électronique et code secret</p>
                                <p><span class="msform">Compensation instantanée :</span> Le Client Platinum est automatiquement compensé sur carte en cas de débit à tord au guichet ou en ligne.</p>
                                <p><span class="msform">Cash-pick up :</span> Nos équipes se déplacent vers le client Platinum, à sa convenance, pour tout rechargement en espèce et chèque bancaire.</p>
                                <p>
                                    <!-- Button -->						
                                <RouterLink to="platinum-noir" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>
                                
                                </p>

                                
                            </div>
                            </div>	<!-- END CONTENT TEXT -->   
                                <div class="col-md-4 div_car">
                                    <img src="@/assets/images/carte-platinum-noire.png" class="img_card_right">

                                    <h2 class=" title_card title_mob" >Carte Visa Platinum Noir</h2>
                                    <p class="title_mob">En partenariat avec UBA, la carte Platinum Abidjan.net est une carte visa prépayée internationale hautement sécurisée qui est au prix de 50.000 FCFA
                                         avec un minimum de rechargement de 100 000 FCFA pour l’activation de la carte.</p>
                                    <!-- Button -->						
                                    <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-right">Commander une carte</a>
                                    <!--btn reponsive-->
                                    <RouterLink to="platinum-noir" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>
                                   
                                   
                                </div>
                                                          
                        </div>
                    </div>

                    <!-- CARTE VIRTUELLE UBA -->
<!--                    <div class="col-md-12 box-card_left">	-->
<!--                        -->
<!--                        <div class="row">-->

<!--                            <div class="col-md-4 div_car">-->
<!--                                    <img src="@/assets/images/UBA-virtuelle.png" class="img_card_left">-->

<!--                                    &lt;!&ndash; Title &ndash;&gt;	-->
<!--                                    <h2 class=" title_card title_mob" >Carte virtuelle APAYM UBA</h2>-->

<!--                                    <p class="title_mob">En partenariat avec UBA, la carte virtuelle Abidjan.net est une carte visa prépayée internationale hautement sécurisée qui est gratuite à partir de l’application APAYM.</p>-->
<!--                                    &lt;!&ndash; Button &ndash;&gt;						-->
<!--                                    <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-left">Commander une carte</a>-->
<!--                                    &lt;!&ndash;btn reponsive&ndash;&gt;-->
<!--                                    <RouterLink to="carte-virtuelle-uba" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>-->
<!--                                </div>-->

<!--                            &lt;!&ndash; CONTENT TEXT &ndash;&gt;-->
<!--                            <div class="col-md-8 txt_disp">-->
<!--                                <div class="content-txt ind-45">-->

<!--                                    &lt;!&ndash; Title &ndash;&gt;	-->
<!--                                    <h2 class=" title_card title1 " >Carte Virtuelle APAYM UBA</h2>-->
<!--                                    &lt;!&ndash; Text &ndash;&gt;-->
<!--                                    <p>En partenariat avec UBA, la carte virtuelle Abidjan.net est une carte visa prépayée internationale hautement sécurisée qui est gratuite à partir de l’application APAYM.</p>-->
<!--                                    <p><span class="msform">Sans engagement :</span> Pas de compte bancaire</p>-->
<!--                                    <p><span class="msform">Sécurisée :</span> L'utilisation de la carte virtuelle APAYM réduit le risque de fraude. Elle ne peut pas être volée, personne ne peut voir votre code PIN car elle est émise uniquement dans l’application APAYM.</p>-->
<!--                                    <p><span class="msform">Achat dans le monde entier :</span> Sur internet (Alibaba/ Netflix/ Booster vos pages Facebook, Compte ITunes…) et dans les commerces</p>-->
<!--                                    <p>-->
<!--                                        &lt;!&ndash; Button &ndash;&gt;						-->
<!--                                    <RouterLink to="carte-virtuelle-uba" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>-->
<!--                                    -->
<!--                                    </p>-->

<!--                                    -->
<!--                                </div>-->
<!--                            </div>	&lt;!&ndash; END CONTENT TEXT &ndash;&gt;   -->
<!--                                -->
<!--                                                      -->
<!--                        </div>-->
<!--                    </div>-->
                    
                    <!-- CARTE VIRTUELLE APAYM-->

<!--                    <div class="col-md-12 box-card_right">	-->
<!--                        -->
<!--                        <div class="row">-->
<!--                        &lt;!&ndash; CONTENT TEXT &ndash;&gt;-->
<!--                        <div class="col-md-8 txt_disp">-->
<!--                        <div class="content-txt ind-45">-->

<!--                            &lt;!&ndash; Title &ndash;&gt;	-->
<!--                            <h2 class=" title_card title1" >Carte Virtuelle APAYM</h2>-->
<!--                            &lt;!&ndash; Text &ndash;&gt;-->
<!--                            <p>En partenariat avec ECOBANK, la carte virtuelle APAYM est une carte Visa prépayée internationale gratuite hautement sécurisée. -->
<!--                                Elle est générée automatiquement lorsqu’un utilisateur crée un compte APAYM et est plafonnée à 200 000 FCFA par défaut.Pour lever la-->
<!--                                 limite des 200 000 FCFA et bénéficier de la capacité complète de 2 000 000 FCFA/jour, l'utilisateur est invité, dans l'application,-->
<!--                                  à compléter son KYC (Informations personnelles et pièces d'identités).</p>-->
<!--                            <p><span class="msform">Instantané :</span> Le processus de versement simplifié et instantané des salaires pour les employés contractuels dépourvus de compte bancaire.</p>-->
<!--                            <p><span class="msform">Frais de mission :</span> Mise à disposition de fonds pour les chargés de missions en local et à l’international</p>-->
<!--                            <p>-->
<!--                                &lt;!&ndash; Button &ndash;&gt;						-->
<!--                            <RouterLink to="carte-virtuelle-ecobank" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>-->
<!--                            -->
<!--                            </p>-->

<!--                            -->
<!--                        </div>-->
<!--                        </div>	&lt;!&ndash; END CONTENT TEXT &ndash;&gt;   -->
<!--                            <div class="col-md-4 div_car">-->
<!--                                <img src="@/assets/images/apaym-virtuelle.png" class="img_card_right">-->

<!--                                &lt;!&ndash; Title &ndash;&gt;	-->
<!--                                <h2 class=" title_card title_mob" >Carte  Virtuelle APAYM</h2>-->
<!--                                <p class="title_mob">En partenariat avec ECOBANK, la carte virtuelle APAYM est une carte Visa prépayée internationale gratuite hautement sécurisée. -->
<!--                                Elle est générée automatiquement lorsqu’un utilisateur crée un compte APAYM et est plafonnée à 200 000 FCFA par défaut.</p>-->
<!--                                &lt;!&ndash; Button &ndash;&gt;						-->
<!--                                <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-right">Commander une carte</a>-->
<!--                                &lt;!&ndash;btn reponsive&ndash;&gt;-->
<!--                                <RouterLink to="carte-virtuelle-ecobank" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>-->
<!--                            </div>-->
<!--                                                      -->
<!--                    </div>-->
<!--                     </div>-->

                     <!-- CARTE APAYM PRO -->
<!--                    <div class="col-md-12 box-card_left">-->

<!--                        <div class="row">-->

<!--                            <div class="col-md-4 div_car">-->
<!--                                    <img src="@/assets/images/carte-apaym-pro.png" class="img_card_pro">-->

<!--                                    <h2 class="title_card title_mob" >Carte Visa APAYM Pro</h2>-->
<!--                                    <p class="title_mob">En partenariat avec ECOBANK, la carte APAYM PRO est une carte dédiée aux marchands et elle peut-être rattachée à un compte APAYM PRO afin de permettre-->
<!--                                         a tous marchands de recevoir de façon instantanée tous les paiements de ses clients vivant en Côte d’Ivoire et à l’etranger.</p>-->
<!--                                    &lt;!&ndash; Button &ndash;&gt;-->
<!--                                    <a href="https://cabine.apaym.com/achat-cartes" class="btn btn-lightorange-left">Commander une carte</a>-->
<!--                                    &lt;!&ndash;btn reponsive&ndash;&gt;-->
<!--                                    <RouterLink to="carte-apaym-pro" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>-->
<!--                                </div>-->

<!--                            &lt;!&ndash; CONTENT TEXT &ndash;&gt;-->
<!--                            <div class="col-md-8 txt_disp">-->
<!--                                <div class="content-txt ind-45">-->

<!--                                    &lt;!&ndash; Title &ndash;&gt;-->
<!--                                    <h2 class=" title_card title1" >Carte Visa APAYM Pro</h2>-->
<!--                                    &lt;!&ndash; Text &ndash;&gt;-->
<!--                                    <p>En partenariat avec ECOBANK, la carte APAYM PRO est une carte dédiée aux marchands et elle peut-être rattachée à un compte APAYM PRO afin de permettre-->
<!--                                         a tous marchands de recevoir de façon instantanée tous les paiements de ses clients vivant en Côte d’Ivoire et à l’etranger. Cette carte permet aussi-->
<!--                                          au marchand de disposer immédiatement de ses fonds de manière sécurisée et peut même les retirer sans frais dans tous les guichets automatiques VISA / GIM UEMOA.</p>-->

<!--                                    <p><span class="msform">Sans engagement :</span> Pas de compte bancaire</p>-->
<!--                                    <p><span class="msform">Sécurisée :</span> Paiements en ligne par 3D Secure, bande magnétique, puce électronique et code secret</p>-->
<!--                                    <p>-->
<!--                                        &lt;!&ndash; Button &ndash;&gt;-->
<!--                                    <RouterLink to="carte-apaym-pro" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>-->

<!--                                    </p>-->


<!--                                </div>-->
<!--                            </div>	&lt;!&ndash; END CONTENT TEXT &ndash;&gt;-->


<!--                        </div>-->
<!--                    </div>-->

                    <!-- CARTE SALAIRE -->
                    <div class="col-md-12 box-card_right">	
                        
                        <div class="row">
                        <!-- CONTENT TEXT -->
                        <div class="col-md-8 txt_disp">
                        <div class="content-txt ind-45">

                            <!-- Title -->	
                            <h2 class=" title_card title1" >Carte salaire Abidjan.net</h2>
                            <!-- Text -->
                            <p class="txt_disp">La carte salaire Visa Abidjan.net est un programme dédiée aux entreprises pour optimiser la gestion de la paye d’une partie de leurs employés ou sous-traitants. Ces derniers disposent immédiatement des fonds, de manière sécurisée.</p>
                            <p class="txt_disp"><span class="msform">Instantané :</span> Le processus de versement simplifié et instantané des salaires pour les employés contractuels dépourvus de compte bancaire.</p>
                            <p class="txt_disp"><span class="msform">Frais de mission :</span> Mise à disposition de fonds pour les chargés de missions en local et à l’international</p>
                            <p class="txt_disp"><span class="msform">Suivi des transactions :</span> Contrôle de la gestion de la paye avec un outil performant, sécurisé et fiable.</p>
                            <p class="txt_disp">
                                <!-- Button -->						
                            <RouterLink to="/carte-classic" class="btn btn-grey">En savoir plus <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>
                            
                            </p>

                            
                        </div>
                        </div>	<!-- END CONTENT TEXT -->   
                            <div class="col-md-4 div_car">
                                <img src="@/assets/images/carte-classique.png" class="img_card_right">

                                 <!-- Title -->	
                            <h2 class=" title_card title_mob" >Carte salaire Abidjan.net</h2>
                            <p class="title_mob">La carte salaire Visa Abidjan.net est un programme dédiée aux entreprises pour optimiser la gestion de la paye d’une partie de leurs employés ou sous-traitants. Ces derniers disposent immédiatement des fonds, de manière sécurisée.</p>
                                <!-- Button -->						
                                <a href="https://apaym.com/pro/souscription" class="btn btn-lightorange-right">Commander une carte</a>
                                <!--btn reponsive-->
                                <RouterLink to="#" class="btn btn-lightorange-left btn_sav_disp">En savoir plus</RouterLink>
                            </div>
                                                      
                    </div>
                </div>

                    
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

        <section id="download-4" class="bg-fixed pro_m p-top-100 download-section division  ">
            <div class="container">
                <div class="row">

                       <p></p>         
                    <!-- DOWNLOAD TEXT -->
                    <div class="col-lg-10 offset-lg-1">	
                        <div class="download-txt">
                            
                            <!-- Title -->
                            <h2 class="h2-xs">Découvrez l'expérience d'achat unique<br> dans nos points de ventes</h2>

                            <!-- Text -->
                            <p class="p-lg">Ne manquez pas l'occasion d'obtenir nos cartes exclusives<br> en visitant nos points de vente dès maintenant !<br> Des designs uniques et des offres spéciales vous attendent.
                            </p>
                            <p><RouterLink to="points-de-vente" class="btn btn_vente">Voir nos points de ventes <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink> </p>

                            


                        </div>
                    </div>	 <!-- END DOWNLOAD TEXT -->                 
  
                </div>	  <!-- End row -->
            </div>	   <!-- End container -->		
        </section>

         <!-- Privilèges -->
         <section id="pro" class="bg-scroll wide-60 content-section division bck_priv sub_section ">
            <div class="container">
                <div class="row d-flex align-items-center">
                    
                    <!-- CONTENT TEXT -->
                    <div class="col-md-7 sct_priv">
                        <div class="content-txt ind-45">

                                    
                            <!-- Title -->	
                            <h2 class="h2-xs " >
                                Profitez de réductions exclusives chez nos partenaires
                            </h2>
                            
                           <!-- Text -->
                           <p>En achetant des cartes chez nous, vous bénéficiez également de privilèges exclusifs chez nos partenaires. Vous pouvez économiser <strong>jusqu'à 20%</strong> sur vos achats grâce à ces réductions exclusives. </p>	
                           <p>N'hésitez pas à nous demander plus d'informations sur les partenaires et les offres disponibles lors de votre prochaine visite en agence. Profitez de ces avantages en achetant vos cartes chez nous !</p>                       
                                            
                            <!-- Text -->	
                            <p class="" >
                            <!-- Button -->						
                            <RouterLink to="privileges" class="btn btn_vente">Voir les privilèges <font-awesome-icon icon="fa-solid fa-arrow-right" /></RouterLink>                    
                            </p>
                        </div>
                    </div>	<!-- END CONTENT TEXT -->

                </div>	   <!-- End row -->		
            </div>	   <!-- End container -->		
        </section>	
        <!-- Fin Privilèges -->

        <footer_menu></footer_menu>
    </div>

</template>

<script>
import interne_menu  from '../components/interne_menu.vue';
import footer_menu  from '../components/footer_menu.vue';
export default{
    name :'apaym_pro',
    components:{
      'interne_menu' :interne_menu,
      'footer_menu' :footer_menu
    } 
}
</script>

<style scoped>
.bck-cartes{
 
    background-image: url(@/assets/images/bck-cartes.png);
    background-position: center center;   
    background-repeat: no-repeat;
    background-size: cover;
  
}



.wide-60 {
    padding-top: 190px;
    padding-bottom: 60px;
}
.btn-blue {
    color: #fff;
    background-color: #000;
    border-color: #000;
}
#download-2 .bg-inner {
    /* background-image: url(../images/download-2.jpg); */
    position: relative;
    z-index: 1;
    background: #261b64;
}
.sct_nav {
    border-bottom: 0px solid #f6f6f6 !important;
}
.box-card{
    background: #fff;
    margin-bottom: 20px;
    height: 470px;
    border-radius: 30px;
    /*box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);*/
    margin-top: 150px;
    padding: 25px;
    border: 4px solid #f3f3f3;
}

.box-card_right{
    background: #fff;
    margin-bottom: 20px;
    height: 486px;
    border-radius: 30px;
    margin-top: 5px;
    padding: 25px;
    border: 4px solid #f3f3f3;
}
.box-card_left{
    background: #fff;
    margin-bottom: 20px;
    height: 445px;
    border-radius: 30px;
    margin-top: 5px;
    padding: 25px;
    border: 4px solid #f3f3f3;
}
h2.h2-xs {
    font-size: 4.25rem !important;
}
.img_card{
    max-width: 300px;
    width: 100%;
    margin-top: 70px;
    margin-bottom: 25px;
    margin-left: 25px;
}
.img_card_right{
    max-width: 300px;
    width: 100%;
    margin-top: 70px;
    margin-bottom: 25px;
    margin-right: 25px;
}
.img_card_left{
    max-width: 300px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 25px;
    margin-left: 25px;
}
.img_card_pro {
    max-width: 300px;
    width: 100%;
    margin-top: 60px;
    margin-bottom: 25px;
    margin-left: 25px;
}

#download-4 p {
     padding: 0 0% !important; 
}
.div_car{
text-align: center;
}
.btn-lightorange{
    background: #FF9E00;
    max-width: 300px;
    width: 100%;
    border-radius: 19px;
    border: none;
    margin-left: 25px;
}
.btn-lightorange-right{
    background: #FF9E00;
    max-width: 300px;
    width: 100%;
    border-radius: 19px;
    border: none;
    margin-right: 25px;
    
}

.btn-lightorange-left{
    background: #FF9E00;
    max-width: 300px;
    width: 100%;
    border-radius: 19px;
    border: none;
    margin-left: 25px;
    
}

.btn-grey{
    background: #f3f3f3;
    width: 170px;
    border-radius: 19px;
    border: none;
    color: #848484;
   
}
.btn-grey:hover{
    background: #261b64;
    width: 170px;
    border-radius: 22px;
    border: none;
    color: #ffffff;
   
}
.title_card{
    font-size: 2.5rem !important;   
    color: #261b64;
}
.msform{
    font-weight: bold;
    color: #261b64;
}

.pro_m{
    background-image: url(@/assets/images/map-bg.png);
}
h2.h2-xs {
    font-size: 2.6rem !important;
}
.btn_vente{
    background: #261b64;
    width: 270px;
    border-radius: 19px;
    border: none;
    color: #ffffff;
}
.bck_priv{
    background-image: url(@/assets/images/bck-privilege.png);
   
}
.sct_priv{
    padding-top: 90px;
    padding-bottom: 50px;
}

.title1{
    display: block ;
}
.title_mob{
    display: none ;  
}
.btn_sav_disp{
    display: none;
}

@media screen and (max-width: 767px) {

    .pro_m{
    background-image: url(@/assets/images/map-bg.png);
    padding-top: 30px !important;
}
    
    .img_card{
        max-width: 550px;
    width: 100% !important;

}
    .badge_sect {
    max-width: 108px !important;
}

.p-top-160 {
    padding-top: 100px;
}

.box-card{
    background: #fff;
    margin-bottom: 20px;
    height: auto;
    border-radius: 30px;
    margin-top: 0px !important;
    padding: 25px;
    border: 4px solid #f3f3f3;
}
.img_card {
    max-width: 300px;
    width: 100%;
    margin-top: -5px;
    margin-bottom: 25px;
    margin-left: 0;
}
.img_card_left {
    max-width: 300px;
    width: 100%;
    margin-top: 20px;
    margin-bottom: 25px;
    margin-left: 0;
}
.btn-lightorange {
    background: #FF9E00;
    width: 300px;
    border-radius: 19px;
    border: none;
    margin-left: 0;
}
.box-card_right {
    background: #fff;
    margin-bottom: 20px;
    height: auto;
    border-radius: 30px;
    margin-top: 5px;
    padding: 25px;
    border: 4px solid #f3f3f3;
}
.box-card_left {
    background: #fff;
    margin-bottom: 20px;
    height: auto;
    border-radius: 30px;
    margin-top: 5px;
    padding: 25px;
    border: 4px solid #f3f3f3;
}
.img_card_pro {
    max-width: 300px;
    width: 100%;
    margin-top: -5px;
    margin-bottom: 25px;
     margin-left: 0; 
}
.img_card_right {
    max-width: 300px;
    width: 100%;
    margin-top: 1px;
    margin-bottom: 25px;
    margin-right: 0;
}
.btn-lightorange-right {
    background: #FF9E00;
    width: 300px;
    border-radius: 19px;
    border: none;
    margin-right: 0;
}
.btn-lightorange-left {
    background: #FF9E00;

    width: 300px;
    border-radius: 19px;
    border: none;
    margin-left: 0;
 
}
.title1{
    display: none !important;
}
.title_mob{
    display: block !important;  
}
.title_card{
    font-size: 2rem !important;   
    color: #261b64;
}
.txt_disp{
    display: none;
}

.wide-60 {
    padding-top: 0px !important;
    padding-bottom: 60px;
}
.bck_priv{
margin-bottom: 20px;
}
.btn_sav_disp{
    display: block !important;
    background: #dbdbdb;
    margin: auto;
    margin-top: 10px;
    color: #515151;
}

}
</style>

